;(function($){

    function Modal() {
        var _ = this;

        $("#modal").iziModal({
        	title: 'Resultado',
		    subtitle: '',
		    headerColor: '#000',
		    transitionIn: 'bounceInDown',
    		transitionOut: 'bounceOutDown',
            closeOnEscape: true,
            closeButton: true,
            padding: 25,
            width: 300,
            timeout:false,
        });

		$(document).on('click', '.open-modal', function (event) {
		    event.preventDefault();

		    $('#modal').iziModal('open');
		    $("#modal .iziModal-content").html(
		    	'<p style="margin: 0.3rem 0;"><strong>Nome: </strong>'+$(this).attr('data-name')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>Colocação Geral: </strong>'+$(this).attr('data-general-placement')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>Número Peito: </strong>'+$(this).attr('data-number')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>Sexo: </strong>'+$(this).attr('data-sex')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>Idade: </strong>'+$(this).attr('data-age')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>Faixa Etária: </strong>'+$(this).attr('data-age-range')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>CL.FX.ET: </strong>'+$(this).attr('data-placement-age-group')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>Equipe: </strong>'+$(this).attr('data-team')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>Tempo: </strong>'+$(this).attr('data-gross-time')+'</p>'+
		    	'<p style="margin: 0.3rem 0;"><strong>Tempo Líquido: </strong>'+$(this).attr('data-liquid-time')+'</p>'+
		    	'<p style="text-align: center"><a target="_blank" href="'+$(this).attr('href')+'" style="background: #ffc927; width: 100%; float: left; padding: 0.5rem 1rem; color: #181818; border-radius: 0.5rem; margin: 0.5rem 0;">Certificado</a></p>'
		    );
		    
		});

	}

    new Modal();

}(jQuery));
